var mod = (module.exports = angular.module('validator', []));

mod.service('$fileValidator', function () {
  // Probably best to ensure this is synchronised with the backend AzureDocRepositoryAPI's Web.config
  var allowedTypes = {
    image: {
      contentTypes: ['image/png', 'image/jpeg', 'image/bmp', 'image/gif'],
      extensions: ['.png', '.jpg', '.jpeg', '.bmp', '.gif'],
    },
    document: {
      contentTypes: [
        'application/pdf',
        'application/msword',
        'applcation/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.text',
        'application/rtf',
        'text/plain',
        'image/png',
        'image/jpeg',
        'image/bmp',
        'image/gif',
      ],
      extensions: [
        '.pdf',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.ods',
        '.odt',
        '.rtf',
        '.txt',
        '.png',
        '.jpg',
        '.jpeg',
        '.bmp',
        '.gif',
      ],
    },
  };

  var flattenToList = function (obj, subkey) {
    const list = [];

    Object.keys(obj).forEach(function (key) {
      list.push(obj[key][subkey]);
    });

    return [...new Set(list.flat())];
  };

  this.GetAllowedTypesByFilter = function (filter) {
    var allowed = {
      contentTypes: [],
      niceMessage: undefined,
    };

    if (filter !== undefined && typeof filter === 'string') {
      filter = filter.toLowerCase();
    }

    if (
      filter === undefined ||
      filter === 'any' ||
      filter === '' ||
      typeof filter !== 'string'
    ) {
      allowed.contentTypes = flattenToList(allowedTypes, 'contentTypes');
      allowed.niceMessage = flattenToList(allowedTypes, 'extensions').join(
        ', '
      );
    } else if (allowedTypes[filter] !== undefined) {
      // The filter is valid, so only check against the content types
      // associated with the filter
      allowed.contentTypes = allowedTypes[filter].contentTypes;
      allowed.niceMessage = allowedTypes[filter].extensions.join(', ');
    }

    return allowed;
  };

  this.ValidateContentType = function (file, filterName) {
    if (file !== undefined) {
      if (filterName !== undefined && typeof filterName === 'string') {
        filterName = filterName.toLowerCase();
      }

      var list = this.GetAllowedTypesByFilter(filterName).contentTypes;

      if (list.includes(file.type)) {
        return true;
      }
    }
    return false;
  };
});
